import { useCallback, useRef, useState } from "react";
import './ActivateCloudStoragePopup.css';
import useOutsideClick from "src/Utils/Hooks/UseOutSideClick/UseOutSideClick";
import Modal from 'src/Utils/CssModules/modal.module.css';
import Button from "src/Components/Button/Button";
import CircularCheckbox from "src/SharedComponents/CircularCheckbox/CircularCheckbox";
import { Trans, useTranslation } from "react-i18next";
import { Config } from "src/Utils/ConfigService/LoadConfig";

interface IActivateCloudStoragePopup{
    onActivate: () => void;
    onClose: () => void;
}

const ActivateCloudStoragePopup: React.FC<IActivateCloudStoragePopup> = ({ onActivate, onClose }) => {
    const { t } = useTranslation();
    const wrapperRef = useRef<HTMLDivElement>(null);
    useOutsideClick(wrapperRef, () => { close() })
    const dataProcessingLink = Config.GetConfigData().dataProcessingAddendumLink;
    const [display, setdisplay] = useState('block');
    const [disableSubmit, setDisableSubmit] = useState<boolean>(true);

    const close = useCallback(() => {
        setdisplay('none');
        onClose();
    }, [onClose]);
    
    const submit = useCallback(() => {
        onActivate();
        setdisplay('none');
    }, [onActivate]);

    return(
        <>
            <div className='row'>
                <div id="myModal" className={`${Modal.modal}`} style={{ display: display, zIndex: 1003 }}>
                    <div className={`${Modal.content} smallcontent`} ref={wrapperRef}>
                        <div className={Modal.header} style={{ textAlign: 'center' }}>
                            <div className='col activate-clinic'>
                                <span>{t('ActivateCloud')}</span>
                            </div>
                        </div>

                        <div className={Modal.body}>
                            <div className='row mt-3' style={{ justifyContent: 'center', textAlign: 'center' }}>
                                <Trans i18nKey='ActivateLicenseDialogMsg'/>
                            </div>
                            <div className='row mt-3' style={{ display: 'flex' }}>
                                <div style={{flex: 1, margin: 'auto'}}>
                                    <CircularCheckbox onChecked={(isChecked) => setDisableSubmit(!isChecked)}/>
                                </div>
                                <div style={{flex: 9, display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                                    <span><Trans i18nKey='ActivateLicenseT&C'/><a href={dataProcessingLink} target="_blank" rel="noreferrer" className="ds-text-primary">{t('DataProcessingAddendum')}</a></span>
                                </div>
                            </div>
                        </div>

                        <div className={Modal.footer}>
                            <div className="row mb-3">
                                <div className='col-6'>
                                    <Button
                                        backgroundColor='none'
                                        color='var(--primary-color)'
                                        testId='close'
                                        onClick={() => { close() }}
                                        text={t('Cancel')}
                                        width='141px'
                                        height='48px'
                                        borderRadius='24px'
                                        borderColor="#D0D0D0" />
                                </div>
                                <div className='col-6 d-flex justify-content-end'>
                                    <Button
                                        backgroundColor='var(--primary-gradient)'
                                        color='white'
                                        testId='ok'
                                        onClick={() => { submit() }}
                                        text={t('Activate')}
                                        width='141px'
                                        height='48px'
                                        disable={disableSubmit}
                                        borderRadius='24px' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ActivateCloudStoragePopup;